<template>
<!-- eslint-disable max-len -->
<list-page
  name="Support Category"
  plural="Support Categories"
  use="_id"
  :display="display"
  page-prefix="/blade/article-categories"
  :fetch="getArticleCategories"
  :remove="deleteArticleCategory"
></list-page>
</template>

<script>
import { mapActions } from 'vuex';

import ListPage from '../../ui/pages/ListPage';

export default {
  components: {
    ListPage,
  },
  methods: {
    ...mapActions([
      'getArticleCategories',
      'deleteArticleCategory',
    ]),
    display({ title: articleCategoryName, updated }) {
      const date = updated && new Date(updated);
      const dateString = date && `(edited ${date.toLocaleDateString()} ${date.toLocaleTimeString()})` || '';
      return `${articleCategoryName} ${dateString}`;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/blade/pages/ArticleCategoriesList.vue